import React, { useEffect, useState } from 'react';
import _, { cloneDeep } from 'lodash';
import { useTable, useSortBy, useFilters, usePagination, useGlobalFilter } from "react-table";

const ListingTable = ({ columns, data, searchText, selectedRow, onShowDetails, getPageData, pageData }) => {

    const [paginationData, setPaginationData] = useState({});
    const {
        getTableBodyProps,
        headerGroups,
        setGlobalFilter,
        prepareRow,
        page,

    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 20 }

    },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,

    );

    useEffect(() => {
        setGlobalFilter(searchText)
    }, [searchText]);

    const generateSortingIndicator = column => {
        return paginationData.selectedSortingColumn ? (paginationData.selectedSortingColumn === column && paginationData.order === "desc" ? " 🔽" : " 🔼") : ""
        //  column.isSorted ? (column.isSortedDesc ? ) : ""
    }

    useEffect(() => {
        setPaginationData(pageData)
    }, [pageData]);

    const pageChangeHandler = (key) => {
        let paginationDataTemp = cloneDeep(paginationData);
        if (key === "next") {
            paginationDataTemp.page = paginationDataTemp.page + 1;
        } else if (key === "prev") {
            paginationDataTemp.page = paginationDataTemp.page - 1;
        } else if (key === "lastPage") {
            paginationDataTemp.page = paginationDataTemp.pageCount;
        } else {
            paginationDataTemp.page = 1
        }

        setPaginationData(paginationDataTemp);
        getPageData(paginationDataTemp)
    }

    const getSortingKey = (key) => {
        let value;
        switch (key) {
            case "Ref_Id":
                value = "id";
                break;

            case "Station":
                value = "station";
                break;

            case "Date & Time":
                value = "date_and_time";
                break;

            case "Reported":
                value = "is_reported_to_staff";
                break;

            case "Opted in":
                value = "is_opted_for_update";
                break;

            case "Name":
                value = "name";
                break;

            case "Email":
                value = "email";
                break;

            case "Details":
                value = "details";
                break;

            case "Status":
                value = "status";
                break;

            case "Email address":
                value = "email";
                break;

            case "Mobile number":
                value = "mobile_number";
                break;

            case "Suggestion":
                value = "suggestions";
                break;

            case "Embarked":
                value = "embarked";
                break;

            case "Disembarked":
                value = "disembarked";
                break;
            default:
                break;
        }

        return value;
    }

    const sortingHandler = (column) => {
        if ((column["Header"] !== "Name" && column["Header"] !== "Email" && column["Header"] !== "Image" && column["Header"] !== "Email address" && column["Header"] !== "Mobile number")) {
            let paginationDataTemp = cloneDeep(paginationData);
            paginationDataTemp.columnname = getSortingKey(column.Header);
            paginationDataTemp.selectedSortingColumn = column.Header
            paginationDataTemp.order = paginationDataTemp.order === 'desc' ? 'asc' : paginationDataTemp.order === 'asc' ? "desc" : "";
            setPaginationData(paginationDataTemp);
            getPageData(paginationDataTemp)
        }
    }

    const pageHandler = (e) => {
        let paginationDataTemp = cloneDeep(paginationData);
        paginationDataTemp.page = e.target.value ? parseInt(e.target.value) : "";

        if (paginationDataTemp.page > paginationData.pageCount) {
            paginationDataTemp.page = paginationData.pageCount
        }
        setPaginationData(paginationDataTemp);
    }

    const onPressEnter = (e) => {
        if (e.keyCode === 13) {
            getPageData(paginationData)
        }
    }

    const sortingFieldHandler = (column) => {
        let className = null
        if ((column["Header"] !== "Name" && column["Header"] !== "Email" && column["Header"] !== "Image" && column["Header"] !== "Email address" && column["Header"] !== "Mobile number")) {
            return className = "cursor-pointer"
        }
    }

    return (
        <>
            <div className="table-section">
                <table className="table table-borderless">
                    <thead>
                        {headerGroups.map((headerGroup, idx) => {
                            return (
                                <tr key={idx}>
                                    {headerGroup.headers.map(column => (
                                        <th className={sortingFieldHandler(column)} onClick={() => sortingHandler(column)} key={column.id}>
                                            <div>
                                                {column.render("Header")}
                                                {(paginationData.selectedSortingColumn && paginationData.selectedSortingColumn === column["Header"]) ? paginationData.order === "desc" ? <i className="fa fa-caret-down"></i> : <i className="fa fa-caret-up"></i> : ""
                                                    // <i className="fa fa-caret-down"></i> 
                                                }
                                                {/* {column["Header"] === "Date & Time" && <i className="fa fa-caret-down"></i>
                                                } */}
                                                {/* {generateSortingIndicator(column["Header"])} */}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            )
                        })}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page.map(row => {
                            prepareRow(row)
                            return (
                                <tr key={row.id} {...row.getRowProps()} onDoubleClick={() => onShowDetails(row)} className={!_.isEmpty(row) && !_.isEmpty(row.original) && row.original.id === (!_.isEmpty(selectedRow) && !_.isEmpty(selectedRow.original) && selectedRow.original.id) ? "row-active" : ""}>
                                    {row.cells.map(cell => {
                                        return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>


            <div className="pagination">
                {pageData &&
                    <>
                        <button className="btn btn-primary pagerPrev disabled-link" onClick={() => pageChangeHandler("firstPage")}
                            disabled={pageData.page === 1 || data.length === 0}>
                        </button>{" "}
                        <button className="btn btn-primary firstI disabled-link" onClick={() => pageChangeHandler("prev")}
                            disabled={pageData.page === 1}
                        >
                        </button>
                        <span className="pagination-number">
                            Page{" "}
                            <strong>
                                <input className="pagination-page" type="number" value={paginationData.page || pageData} onKeyUp={onPressEnter} min="1" max={pageData.pageCount} onChange={pageHandler} />
                                of {pageData.pageCount}
                            </strong>
                        </span>
                        <button className="btn btn-primary lastI disabled-link"
                            disabled={pageData.page === pageData.pageCount}
                            onClick={() => pageChangeHandler("next")} disabled={pageData.page === pageData.pageCount}>
                        </button>{" "}
                        <button className="btn btn-primary pagerNext disabled-link" onClick={() => pageChangeHandler("lastPage")}
                            disabled={pageData.page === pageData.pageCount || data.length === 0}
                        >
                        </button>{" "}
                    </>
                }
            </div>

        </>
    )

}

export default ListingTable;